import { createSlice } from '@reduxjs/toolkit'

export const notificationSlice = createSlice({
    name: 'notifications',
    initialState: {
        notificationsData: [],
    },
    reducers: {
        addNotifications: (state, action) => {
            state.notificationsData = action.payload;
        },
    },
})

export const { addNotifications } = notificationSlice.actions

export default notificationSlice.reducer